export default "__VITE_ASSET__Chfo$4cy__"